
export enum LanguageEnum {
	CZ = 'CZ',
	SK = 'SK',
}